import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import track from "react-tracking";
class ThankYouEmail extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div className="content mix-content_centerText">
				<div className="wrapper wrapper_narrow">
					<div className="vr vr_x10">
						<h2 className="hdg js-pageHeader">
							<FormattedMessage id="thankYouEmail.header" defaultMessage="Thank You"/>
						</h2>
					</div>
					<div className="vr vr_x4">
						<div className="text">
							<FormattedMessage tagName="p" id="thankYouEmail.message" defaultMessage="Please note that it may take up to one business day from receipt of this request for the update to be completed in our system."/>
						</div>
					</div>
				</div>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
/* Create and export container component that wraps ThankYouEmail for property binding */
export default track({ page: "ThankYouEmail" }, { dispatchOnMount: true })(connect()(ThankYouEmail));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/ThankYouEmail.tsx